export default "__VITE_ASSET__D4sY99dd__"